import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MaterialsState } from '../reducers/materials.reducer';
import { MATERIALS_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<MaterialsState>(MATERIALS_FEATURE_KEY);

export const selectMaterials = createSelector(selectState, (state: MaterialsState) => state.materials);
export const selectLoaded = createSelector(selectState, (state: MaterialsState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: MaterialsState) => state.loading);
export const selectValue = createSelector(selectState, (state: MaterialsState) => state.value);
export const selectTotal = createSelector(selectState, (state: MaterialsState) => state.total);
export const selectLookupLoaded = createSelector(selectState, (state: MaterialsState) => state.lookupLoaded);
export const selectLookup = createSelector(selectState, (state: MaterialsState) => state.lookup);
export const selectLookupOptions = createSelector(selectLookup, (lookup) => lookup.map((material) => ({ label: material.name, value: material.id })));
